<template>
    <div class="content">
        
        <iframe src="//sharecad.org/cadframe/load?url=http://www.cadsofttools.com/dwgviewer/floorplan.dwg" scrolling="no"></iframe>
        
    </div>
</template>

<script>
  export default {
    name: "MonitoringOrder"
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/MonitoringOrder.vue